import axios from "axios";

export { importTrackingActions };

axios.defaults.withCredentials = true;

function importTrackingActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getImportTracking,
    //getByCodeStatusReasons,
    exportDataImportTracking,
    exportFileImportTrackingDataById,
    exportErrorImportTrackingDataById,
    statusList,
  };

  async function exportDataImportTracking(
    tenant: String | undefined,
    fileName?: String,
    status?: String,
    startDateFrom?: any,
    startDateTo?: any
  ) {
    const exportAllDataImportTracking = await axios.get(
      `${baseUrl}/masterdatavehicle/importtracking/excel`,
      {
        params: {
          tenant: tenant,
          fileName: fileName,
          status: status,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
        },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
        //responseType:'stream' || 'blob'
      }
    );

    return exportAllDataImportTracking;
  }

  async function getImportTracking(
    tenant: String | undefined,
    pageNumber: number,
    pageSize: number,
    fileName?: String,
    status?: String,
    startDateFrom?: any,
    startDateTo?: any
  ) {
    const getAllImportTracking = await axios.get(
      `${baseUrl}/masterdatavehicle/importtracking`,
      {
        params: {
          tenant: tenant,
          pageNumber: pageNumber,
          pageSize: pageSize,
          fileName: fileName,
          status: status,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
        },
      }
    );

    return getAllImportTracking;
  }

  async function statusList() {
    return await axios.get(
      `${baseUrl}/masterdatavehicle/importtracking/status/all`
    );
  }

  async function exportFileImportTrackingDataById(
    tenant: String | undefined,
    id?: String
  ) {
    const exportFileById = await axios.get(
      `${baseUrl}/masterdatavehicle/importtracking/${id}/file`,
      {
        params: { tenant: tenant },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportFileById;
  }

  async function exportErrorImportTrackingDataById(
    tenant: String | undefined,
    id: String
  ) {
    const exportErrorById = await axios.get(
      `${baseUrl}/masterdatavehicle/importtracking/${id}/errorfile`,
      {
        params: { tenant: tenant },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportErrorById;
  }
}
